import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL } from '../data/breakFreeContent';
import { trackPixelEvent } from '../utils/metaPixel';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 1200);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-149" data-mp="3ubkdw5bpgvz5">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-champagne/25 bg-charcoal-950/95 px-4 py-3 backdrop-blur lg:hidden" data-id="element-150" data-mp="3ueg7jhgisyhs">
          <div className="mx-auto flex max-w-xl items-center gap-4" data-id="element-151" data-mp="gyim89un8gqc">
            <div className="min-w-0 leading-tight" data-id="element-152" data-mp="75cjin2gpd8e">
              <p className="font-display text-2xl font-semibold text-ivory-50" data-id="element-153" data-mp="765gwxfj6qdv">$27</p>
              <p className="truncate text-[10px] uppercase tracking-[0.14em] text-muted" data-id="element-154" data-mp="28dqk7ujbcbs">
                6 Volumes + 6 Bonuses
              </p>
            </div>
            <a href={CHECKOUT_URL} onClick={() => trackPixelEvent('InitiateCheckout', {
          content_name: 'BREAK FREE',
          value: 27,
          currency: 'USD'
        })} className="flex-1 rounded-full bg-champagne px-4 py-3.5 text-center text-[11px] font-semibold uppercase tracking-[0.14em] text-charcoal-950 transition-colors duration-150 ease-out hover:bg-champagne-light" data-id="element-155" data-mp="c4gr599qn2wm">
              I'm ready to break free
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}